import './SessionAvailabilitiesCheckboxes.scss';

import { useEffect, useState } from 'react';
import { NOT_AVAILABLE_VALUE } from '../../utils/constants';
import { Option } from '../../models/generic';

interface Props {
  options: Option[];
  onChange: (value: any) => void;
}

const SessionAvailabilitiesCheckboxes = ({ options, onChange }: Props) => {
  const initCheckboxStates = (): {
    id: string;
    label: string;
    checked: boolean;
  }[] => {
    return options.map((o: Option) => {
      return {
        id: o.value,
        label: o.label,
        checked:
          !checkboxStates || !checkboxStates.length
            ? false
            : checkboxStates.find((c) => c.id === o.value)!.checked!
      };
    });
  };

  const [checkboxStates, setCheckboxStates] = useState<
    { id: string; label: string; checked: boolean }[]
  >(initCheckboxStates());

  const handleCheckboxesStates = (
    value: string,
    checked: boolean,
    index: number
  ) => {
    let checkboxes = [...checkboxStates];
    checkboxes[index].checked = checked;

    if (value === NOT_AVAILABLE_VALUE) {
      checkboxes = checkboxes.map(
        (c: { id: string; label: string; checked: boolean }) => {
          return {
            id: c.id,
            checked:
              value === NOT_AVAILABLE_VALUE && c.id !== NOT_AVAILABLE_VALUE
                ? false
                : c.checked,
            label: c.label
          };
        }
      );
    } else {
      const notAvailableCheckbox = checkboxes.find(
        (cb) => cb.id === NOT_AVAILABLE_VALUE
      );
      if (notAvailableCheckbox?.checked) {
        notAvailableCheckbox.checked = false;
      }
    }
    setCheckboxStates(checkboxes);
  };

  useEffect(() => {
    onChange(checkboxStates.filter((cc) => cc.checked).map((c) => c.id));
  }, [checkboxStates]);

  useEffect(() => {
    if (options[0].label === checkboxStates[0].label) return;
    setCheckboxStates(initCheckboxStates());
  }, [options]);

  const handleOnClick = (value: string, index: number) => {
    const checkbox: any = document.getElementById(`custom-input-${index}`);
    const checked = checkbox?.checked;

    handleCheckboxesStates(value, checked, index);
  };

  return (
    <div id="sessionIds" className="availabilities-section">
      {checkboxStates.map(({ id, label, checked }, index) => {
        return (
          <div
            id={`custom-checkbox-${index}`}
            key={`custom-checkbox-${index}`}
            className="chk-box"
          >
            <label className="chk-label" htmlFor={`custom-label-${index}`}>
              <input
                type="checkbox"
                id={`custom-input-${index}`}
                name={label}
                value={id}
                checked={checked}
                onClick={() => handleOnClick(id, index)}
              />
              {label}
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default SessionAvailabilitiesCheckboxes;
